import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sub-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sub-header.component.html',
  styleUrl: './sub-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubHeaderComponent {
  @Input() badgeText: string = 'Healthcare Datasets';
  @Input({ required: true }) title!: string;
  @Input({ required: true }) description!: string;
  @Input() iconSrc: string = '/icons/sparkle.svg';
  @Input() variant: 'default' | 'leaderboard' = 'default';
}
